<template>
  <div class="home-center">
	
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      
    };
  },
  // mixins: [minxin],

  computed: {},

  created() {
	  console.log("blank");
  },
  mounted() {
  	
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
.home-center {
  .boxs {
    display: flex;
    flex-wrap: wrap;
    .box {
      width: 200px;
      height: 120px;
      margin: 0 20px 20px 0;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .icon {
        font-size: 37px;
      }
      .name {
        margin-top: 13px;
        font-size: 20px;
      }
    }
  }
}
</style>